<template>
  <div
    v-if="event"
    class="d-flex justify-content-end align-items-center">
    <attendance-button
      class="mr-2"
      type="attend"
      :active="isAttend"
      @click="() => isAttend ? $emit('cancel') : $emit('attend')">
      参加
    </attendance-button>
    <attendance-button
      type="absence"
      :active="isAbsence"
      @click="() => isAbsence ? $emit('cancel') : $emit('absence')">
      不参加
    </attendance-button>
  </div>
</template>

<script>
import AttendanceButton from '@/components/parts/AttendanceButton'
export default {
  components: {
    AttendanceButton
  },
  props: {
    event: {
      type: Object,
      default: null
    },
  },
  computed: {
    isAttend() {
      if (this.event === null) {
        return false
      }
      return !!this.event.myReply?.isAttend
    },
    isAbsence() {
      if (this.event === null) {
        return false
      }
      if (!this.event.myReply) {
        return false
      }
      return !this.event.myReply.isAttend
    }
  }
}
</script>

<style>

</style>